import { PromptTemplateEngineOverride } from "@/queries/smart-tables";

export interface BrandVisibilityModelSelection {
  id: string;
  label: string;
  engine: PromptTemplateEngineOverride;
}

export interface BrandVisibilityPresetSubmitPayload {
  domain: string;
  queries: string[];
  models: {
    label: string;
    engine: PromptTemplateEngineOverride;
  }[];
}

export const BRAND_VISIBILITY_DEFAULT_QUERY_COUNT = 8;

export const makeBrandVisibilityModelId = (prefix = "brand-model") =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
